<div>
  <form *ngIf="tagForm" [formGroup]="tagForm" (ngSubmit)="updateTag()">
    <!-- Header -->
    <div class="
        md:pl-4
        pl-3
        pr-5
        py-3
        flex
        align-items-center
        relative
        border-bottom-1 border-300
      ">
      <div class="flex align-items-center">
        <h2 class="mb-0 text-sm">
          {{
          activeTag
          ? ('ADMIN.APPOINTMENT.EDIT_TAG' | translate)
          : ('ADMIN.APPOINTMENT.ADD_TAG' | translate)
          }}
        </h2>
      </div>
      <div class="
          fa fa-times text-xl
          opacity-50
          absolute
          right-0
          top-0
          mt-3
          pt-1
          mr-3
          md:mr-4
          cursor-pointer
        " (click)="closeDialog()"></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-100 px-4 py-3 text-sm">


      <!-- Service Category Name (English) -->
      <div class="mb-1">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'ADMIN.APPOINTMENT.TAG_NAME' | translate }}
          <span *ngIf="isSecondaryLanguage">({{ primaryLanguage | translate }})
          </span></label>
        <input formControlName="name_primary_language" type="text" pInputText class="w-full text-sm" placeholder=""
          value="Personal Training" />
      </div>
      <app-error-msg *ngIf="NamePrimary?.touched" [errors]="NamePrimary?.errors"
        [fieldLabel]="'ADMIN.APPOINTMENT.TAG_NAME' | translate">
      </app-error-msg>
      <!-- Service Category Name (English) -->

      <!-- Service Category Name (French) -->
      <div class="mt-3 mb-1" *ngIf="isSecondaryLanguage">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'ADMIN.APPOINTMENT.TAG_NAME' | translate }} ({{
          secondaryLanguage | translate
          }})</label>
        <input formControlName="name_secondary_language" type="text" pInputText class="w-full text-sm" placeholder=""
          value="Personal Training" />
      </div>

      <app-error-msg *ngIf="NameSecondary?.touched" [errors]="NameSecondary?.errors"
        [fieldLabel]="'ADMIN.APPOINTMENT.TAG_NAME' | translate">
      </app-error-msg>
      <!-- Service Category Name (French) -->

    </div>
    <!-- Content -->

    <!-- Footer -->
    <div class="
        p-3
        flex
        justify-content-between
        align-items-center
        border-top-1 border-300
      ">
      <button pButton pRipple type="button" label="{{ 'ADMIN.COMMON.CANCEL' | translate }}" styleClass="text-sm"
        class="p-button-text text-sm" (click)="closeDialog()"></button>
      <button pButton pRipple type="submit" label="{{ 'ADMIN.COMMON.SAVE' | translate }}" class="text-sm"></button>
    </div>
    <!-- Footer -->
  </form>
</div>

